import { request } from 'api';
import {
  Contracts,
  InvitationCooperate,
  InvitationCooperateListQueryDto,
  InvitationCooperateRequestDto,
  InvitationResendRequestDto,
  StatusList,
} from './types';

export const InvitationService = {
  getUserAgentFromInvitation() {
    return request<boolean>('get', '/api/Invitation/InvitationCooperate/UserAgent');
  },
  getInvitationCooperateList(data: InvitationCooperateListQueryDto) {
    return request<Contracts>('post', '/api/Invitation/InvitationCooperate/List', {
      data,
    });
  },
  sendInvite(data: InvitationCooperateRequestDto) {
    return request<InvitationCooperate>('post', '/api/Invitation/InvitationCooperate', { data });
  },
  resendInvite(data: InvitationResendRequestDto) {
    return request<void>('post', '/api/Invitation/InvitationCooperate/Resend', {
      data,
    });
  },
  getStatuses() {
    return request<StatusList>('get', '/api/Invitation/InvitationCooperateDictionary/Statuses');
  },
};
